import { fromJS } from 'immutable';
import { basicSort } from '../../../../util/sortUtils';
import { sort } from '../data/marigramReduxConstants';

export const MARIGRAM_SEARCH_REQUEST = 'MARIGRAM_SEARCH_REQUEST';
export const MARIGRAM_SEARCH_SUCCESS = 'MARIGRAM_SEARCH_SUCCESS';
export const MARIGRAM_SEARCH_FAILURE = 'MARIGRAM_SEARCH_FAILURE';

export const MARIGRAM_SEARCH_CLEAR = 'MARIGRAM_SEARCH_CLEAR';
export const MARIGRAM_SEARCH_CLEAR_REDIRECT = 'MARIGRAM_SEARCH_CLEAR_REDIRECT';

export const MARIGRAM_SEARCH_REGION_REQUEST = 'MARIGRAM_SEARCH_REGION_REQUEST';
export const MARIGRAM_SEARCH_REGION_SUCCESS = 'MARIGRAM_SEARCH_REGION_SUCCESS';
export const MARIGRAM_SEARCH_REGION_FAILURE = 'MARIGRAM_SEARCH_REGION_FAILURE';

export const MARIGRAM_SEARCH_COUNTRY_REQUEST = 'MARIGRAM_SEARCH_COUNTRY_REQUEST';
export const MARIGRAM_SEARCH_COUNTRY_SUCCESS = 'MARIGRAM_SEARCH_COUNTRY_SUCCESS';
export const MARIGRAM_SEARCH_COUNTRY_FAILURE = 'MARIGRAM_SEARCH_COUNTRY_FAILURE';

export const MARIGRAM_SEARCH_LOCATION_REQUEST = 'MARIGRAM_SEARCH_LOCATION_REQUEST';
export const MARIGRAM_SEARCH_LOCATION_SUCCESS = 'MARIGRAM_SEARCH_LOCATION_SUCCESS';
export const MARIGRAM_SEARCH_LOCATION_FAILURE = 'MARIGRAM_SEARCH_LOCATION_FAILURE';

export const MARIGRAM_SEARCH_STATE_REQUEST = 'MARIGRAM_SEARCH_STATE_REQUEST';
export const MARIGRAM_SEARCH_STATE_SUCCESS = 'MARIGRAM_SEARCH_STATE_SUCCESS';
export const MARIGRAM_SEARCH_STATE_FAILURE = 'MARIGRAM_SEARCH_STATE_FAILURE';

export const MARIGRAM_DATA_SORT = 'MARIGRAM_DATA_SORT';


const initialState = fromJS({
  searching: false,
  fetched: false,
  marigrams: [],
  queryParameters: {},
  searchRedirect: false,

  fetchedRegions: false,
  regions: [],
  fetchedCountries: false,
  countries: [],
  fetchedLocations: false,
  locations: [],
  fetchingStates: false,
  states: [],

  sort,
});

// default param first is the redux convention https://redux.js.org/tutorials/fundamentals/part-3-state-actions-reducers
// eslint-disable-next-line default-param-last
export const marigramSearchReducer = (state = initialState, action) => {
  switch (action.type) {
    case MARIGRAM_SEARCH_CLEAR_REDIRECT:
      return state.set('searchRedirect', false);
    case MARIGRAM_SEARCH_CLEAR:
      return initialState.merge(fromJS({
        sort: state.get('sort'),
      }));
    case MARIGRAM_DATA_SORT:
      return state.merge(fromJS({
        marigrams: basicSort(action.sort, state.get('marigrams')),
        sort: action.sort,
      }));

    case MARIGRAM_SEARCH_REQUEST:
      return state.merge(fromJS({
        searching: true,
        fetched: false,
        queryParameters: action.queryParameters,
        searchRedirect: Boolean(action.searchRedirect),
      }));
    case MARIGRAM_SEARCH_SUCCESS:
      return state.merge(fromJS({
        searching: false,
        fetched: true,
        marigrams: basicSort(state.get('sort'), fromJS(action.response.items)),
      }));
    case MARIGRAM_SEARCH_FAILURE:
      return state.merge(fromJS({
        searching: false,
        fetched: true,
      }));

    case MARIGRAM_SEARCH_REGION_REQUEST:
      return state.merge(fromJS({
        fetchedRegions: false,
      }));
    case MARIGRAM_SEARCH_REGION_SUCCESS:
      return state.merge(fromJS({
        fetchedRegions: true,
        regions: action.response.items,
      }));
    case MARIGRAM_SEARCH_REGION_FAILURE:
      return state.merge(fromJS({
        fetchedRegions: true,
      }));

    case MARIGRAM_SEARCH_COUNTRY_REQUEST:
      return state.merge(fromJS({
        fetchedCountries: false,
      }));
    case MARIGRAM_SEARCH_COUNTRY_SUCCESS:
      return state.merge(fromJS({
        fetchedCountries: true,
        countries: action.response.items,
      }));
    case MARIGRAM_SEARCH_COUNTRY_FAILURE:
      return state.merge(fromJS({
        fetchedCountries: true,
      }));

    case MARIGRAM_SEARCH_LOCATION_REQUEST:
      return state.merge(fromJS({
        fetchedLocations: false,
      }));
    case MARIGRAM_SEARCH_LOCATION_SUCCESS:
      return state.merge(fromJS({
        fetchedLocations: true,
        locations: action.response.items,
      }));
    case MARIGRAM_SEARCH_LOCATION_FAILURE:
      return state.merge(fromJS({
        fetchedLocations: true,
      }));

    case MARIGRAM_SEARCH_STATE_REQUEST:
      return state.merge(fromJS({
        fetchingStates: true,
      }));
    case MARIGRAM_SEARCH_STATE_SUCCESS:
      return state.merge(fromJS({
        fetchingStates: false,
        states: action.response.items,
      }));
    case MARIGRAM_SEARCH_STATE_FAILURE:
      return state.merge(fromJS({
        fetchingStates: false,
        states: initialState.get('states'),
      }));

    default:
      return state;
  }
};
